import { render, staticRenderFns } from "./DialogConfirmacaoEntrega.vue?vue&type=template&id=1a97db7a&scoped=true"
import script from "./DialogConfirmacaoEntrega.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogConfirmacaoEntrega.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a97db7a",
  null
  
)

export default component.exports